import React from 'react';
import styled from 'styled-components';
import bgImg from '../../styles/images/bg-section-2.png';
import FadeInUp from '../shared/Animation/FadeInUp';
import i18n from '../../config/i18n';

const MainSection = styled.div`
  width: 100%;
  background: linear-gradient(to right, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
`;

const H3 = styled.h3`
  color: #fff;
  font-size: 42px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2em;
`;

const MapContainer = styled.div`
  width: 100%;
  padding: 20px;
  background: #fff;
  margin-bottom: 60px;
`;

const StyledImg = styled.img`
  width: 100%;
`;

const StyledWrap = styled.div`
  width: 100%;
  padding: 5em 0 0 0;

  @media screen and (max-width: 812px) {
    padding: 1em 0;
  }
`;

function FindUs() {
  return (
    <StyledWrap>
      <StyledImg alt="bg" src={bgImg} />
      <MainSection>
        <div className="container">
          <FadeInUp>
            <H3>
              {i18n.t('find_us')}
            </H3>
            <MapContainer>
              <iFrame
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52961.77462401357!2d-117.89098119956437!3d33.938275302304575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcd4c345cd2613%3A0x291b21c676cf9a2a!2sBrea%2C+CA+92821%2C+USA!5e0!3m2!1sen!2sfr!4v1515338612262"
                width="100%"
                height="325"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen=""
              />
            </MapContainer>
          </FadeInUp>
        </div>
      </MainSection>
    </StyledWrap>
  );
}

export default FindUs;



// WEBPACK FOOTER //
// ./src/components/landing/FindUs.js